import React from "react";




let moment = require('jalali-moment');


class Day extends React.Component {

    state = {
        isOpen: false,
        startOfMonth: '',
        endOfMonth: '',
        month: { startDay: 0, daysCount: 30 },
        monthFromNow: 0,
        today: '',
        hours: [],
        sections: [],
        sectionsPerHour: 2,
        currentTime: null,
        sectionsHeigth: 700,
        timeIndicatorTop: -1,
        data: [],
        rawData: [

            { _id: 2, sTime: 1638940080000, duration: 120, title: "Pouya Pezhman" },
            { _id: 1, sTime: 1638937800000, duration: 38, title: "Pouya Pezhman" },

            { _id: 3, sTime: 1639074600000, duration: 30, title: "Pouya Pezhman" },
            { _id: 5, sTime: 1639035000000, duration: 30, title: "Pouya Pezhman" },

            { _id: 4, sTime: 1639078200000, duration: 30, title: "Pouya Pezhman" },
            { _id: 6, sTime: 1639036800000, duration: 30, title: "Maryam Ghasemi" },
            { _id: 7, sTime: 1639038600000, duration: 30, title: "Other User" },
            { _id: 8, sTime: 1639038600000, duration: 30, title: "Pouya Pezhman" },
            { _id: 9, sTime: 1639038600000, duration: 30, title: "Maryam Ghasemi" },


        ],

    }
    componentDidMount() {


        this.setState({ title: this.props.title, today: new Date().getTime() })
        window.addEventListener('resize', this.changeWidth);
        setTimeout(() => {
            this.changeWidth()
        }, 100);

        if (this.props.title) {
            this.setDay(0, this.props.title)

        } else {
            this.setDay(0)
        }

        this.getCurrentTime()
        this.interval = setInterval(() => {
            this.getCurrentTime()
        }, 60000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    getCurrentTime() {
        let now = new Date().getTime()
        let dayStart = moment(now).startOf('day').valueOf()
        let dayEnd = moment(now).endOf('day').valueOf()

        if (this.state.day && dayStart >= this.state.day?.start) {
            // let difference = now - start 
            var duration = moment.duration(moment(now).diff(moment(dayStart)));
            var minutes = duration.asMinutes();

            // console.log(minutes)

            let baseHeigth = this.state.sectionsHeigth / (60 / this.state.sectionsPerHour)

            // console.log(baseHeigth)
            let top = Number((baseHeigth * minutes).toFixed(5))
            // console.log(top)


            this.setState({ currentTime: new Date().getTime(), timeIndicatorTop: top })
        } else {
            this.setState({ timeIndicatorTop: -1 })
        }
    }


    changeWidth = () => {
        if (this.calender) {
            let width = this.calender.getBoundingClientRect().width
            this.setState({ width })
        }
    }


    changeMonth(number) {
        this.setDay(this.state.monthFromNow + number)
        this.setState({ monthFromNow: this.state.monthFromNow + number })
    }

    setDay(fromNow, startDate) {


        let now = new Date();
        let hours = []
        let sections = []

        let start = moment(now).startOf('day').add(fromNow, 'days').startOf('day')
        let end = moment(now).startOf('day').add(fromNow, 'days').endOf('day')

        if (startDate) {
            start = moment(startDate).add(fromNow, 'days').startOf('day')
            end = moment(startDate).add(fromNow, 'days').endOf('day')
        }



        // console.log(moment(now).add(fromNow, 'month').daysInMonth())

        let minutes = 60 / this.state.sectionsPerHour

        for (let i = 0; i < 24; i++) {
            let dName = i + ' am'
            let tempName = i

            if (i > 11) {
                dName = i - 12 + ' pm'
                tempName = i - 12
            }
            if (i == 0) {
                dName = '12 am'
                tempName = 12
            }
            if (i == 12) {
                dName = '12 pm'
                tempName = 12
            }
            let startOfHour = moment(start).add(i, 'hours').valueOf()
            let endOfHour = moment(start).add(i + 1, 'hours').valueOf() - 1


            for (let j = 0; j < this.state.sectionsPerHour; j++) {

                let startOfSection = moment(startOfHour).add(j * minutes, 'minutes').valueOf()
                let endOfSection = moment(startOfHour).add((j + 1) * minutes, 'minutes').valueOf() - 1

                let sName = this.makeTwoDigits(tempName) + ':' + this.makeTwoDigits(String(minutes * j)) + (i > 11 ? ' pm' : ' am')


                sections.push({ hour: i, sName, dName: j == 0 ? dName : null, start: startOfSection, end: endOfSection, hStart: startOfHour, hEnd: endOfHour, data: [] })

            }

            hours.push({ hour: i, dName, start: startOfHour, end: endOfHour })


        }

        // console.log(hours)
        // console.log(sections)

        // let newDate = [Number(moment(start).format('YYYY')), moment(start).format('M') - 1, 1]

        this.setState({ hours, sections, day: { start, end } }, () => {
            this.arrangeData()
            this.getCurrentTime()

        })

    }

    // setDay(day, dayNumber) {

    //     this.setState({ title: day.start })
    //     this.props.onChange(this.props.headerkey, { type: 'changeDay', newDay: day.start, dayNumber })

    // }

    makeTwoDigits(number) {
        let final = number
        if (number && number.length < 2) {
            final = "0" + String(number)
        }
        return final
    }



    arrangeData = () => {
        // console.log("arrangeData")
        let rawData = this.state.rawData
        let sections = this.state.sections
        let heightPerMinute = this.state.sectionsHeigth / (60 / this.state.sectionsPerHour)

        if (Array.isArray(rawData)) {

            rawData.forEach(data => {
                let sTime = moment(data.sTime).valueOf()
                let eTime = data.eTime ? moment(data.eTime).valueOf() : null
                if (eTime == null) {
                    eTime = moment(sTime).add(data.duration, 'minutes').valueOf()
                }
                data.sTime = sTime
                data.eTime = eTime

            })


            rawData.forEach(data => {
                // let temp = new Date(data.sTime)
                // console.log(temp)
                // console.log(moment(temp).valueOf())
                let sTime = data.sTime
                let eTime = data.eTime
                // if (eTime == null) {
                //     eTime = moment(sTime).add(data.duration, 'minutes').valueOf()
                // }

                // console.log(sTime)

                // console.log(eTime)


                // console.log(numberOfMatches)
                // console.log(moment(sTime).format('hh:mm'))
                // console.log(moment(eTime).format('hh:mm'))
                let added = false
                sections.forEach(section => {
                    // console.log(section.hEnd <= sTime)

                    if (!added && section.start <= sTime && section.end >= sTime) {
                        let parallels = 1
                        // let tempPos = 0

                        // console.log(moment(section.end).format('hh:mm'))
                        // console.log(moment(section.start).format('hh:mm'))
                        // console.log(data._id)
                        // console.log("MATCHES")

                        rawData.forEach(element => {
                            // console.log(data._id)

                            // console.log(element.eTime >= sTime)
                            // console.log(element.eTime)
                            // console.log(sTime)

                            // console.log(element.sTime <= eTime)
                            if ((element._id != data._id) && (element.eTime > sTime) && (element.sTime < eTime)) {

                                console.log(element._id)

                                if (element.parallelPos == null) {
                                    element.parallelPos = 0
                                }
                                element.parallelPos = element.parallelPos + 1
                                parallels = parallels + 1

                            }
                        });

                        let parallelPos = data.parallelPos ?? 0
                        if (data.parallelPos == null) {

                        }


                        let height = ((eTime - sTime) / 60000) * heightPerMinute
                        let top = ((sTime - section.start) / 60000) * heightPerMinute

                        let myData = { _id: data._id, title: data.title, sTime, eTime, top, height, parallels, parallelPos: parallelPos }

                        // console.log(moment(sTime).format('hh:mm'))
                        // console.log(moment(section.hStart).format('hh:mm'))

                        // console.log((sTime - section.hStart) / 60000)

                        // console.log(top)
                        console.log(myData)

                        // let baseHeigth = this.state.sectionsHeigth / (60 / this.state.sectionsPerHour)

                        // console.log(baseHeigth)
                        // let top = Number((baseHeigth * minutes).toFixed(5))

                        section.data.push(myData)
                        added = true
                        // console.log(section)
                    }
                });

            });
        }
    }


    render() {

        let info = this.props.info
        // console.log(this.state.hours)
        return (
            <div ref={el => this.calender = el} className='w-100' style={{ position: 'relative' }}>
                <div className='position-relative ' >

                    <div className="text-center text-smaller py-1 cursor-pointer" style={{ color: '#666', }}>

                    </div>

                    <div className="d-flex" style={{ width: '100%', flexDirection: "column" }}>



                        <div className="w-100" style={{ height: "21px", display: "flex", flexDirection: "row", fontSize: "8px" }}>
                            {this.state.sections.map((prop, index) => {
                                let isCurrentHour = false
                                if (this.state.timeIndicatorTop >= 0 && prop.dName && this.state.currentTime >= prop.hStart && this.state.currentTime <= prop.hEnd) {
                                    isCurrentHour = true
                                }
                                return (
                                    <div key={index} className="w-100" style={{ padding: '2px 2px' }}>
                                        {prop.dName && (
                                            <p className=" text-end" style={{ fontSize: "9px", marginTop: -10, color: isCurrentHour ? '#ee5050' : '#666', }}>{prop.dName}</p>
                                        )}
                                    </div>
                                )
                            })}
                        </div>



                        <div className="  text-center h-100 w-100" style={{ background: "white", display: "flex", flexDirection: "row" }}>
                            {this.state.sections.map((prop, index) => {

                                return (
                                    <div key={index} className="w-100 " style={{ border: '1px solid #eef3f6', minHeight: this.state.sectionsHeigth }}>
                                        <div className="daily-cal-section-body d-flex   w-100 h-100  cursor-pointer position-relative">
                                            <div className="w-100 h-100 flexc justify-content-end" style={{ pointerEvents: 'none', color: '#666' }}>
                                                <p className="daily-cal-section-time  position-absolute text-smallest px-2" >{prop.sName}</p>
                                            </div>
                                            {prop.data && prop.data.map((one, j) => {
                                                // if (one.section == prop.id) {
                                                return (
                                                    // <div className="" style={{ width: 100 / (one.parallels) + '%', left: ((100 / (one.parallels)) * one.parallelPos) + '%', padding: '0px 1px 1px 1px', position: 'absolute',zIndex:1, top: one.top, height: one.height }}>

                                                    <div className="" style={{ width: 220, left: (220 * one.parallelPos), padding: '0px 3px 1px 3px', position: 'absolute', zIndex: 1, top: one.top, height: one.height }}>

                                                        <div className="w-100 h-100 d-flex position-relative " style={{ borderRadius: 4, overflow: 'hidden', color: '#fff', background: 'linear-gradient(to right,#50497f,#60398f)', border: '1px solid #eee', padding: '0px 0px', boxShadow: '0px 0px 30px #10203010' }}>
                                                            {/* <div style={{ backgroundColor: '#30a0ff', height: '100%', marginTop: 0, width: 4, borderRadius: 0 }}></div> */}

                                                            <div className="w-100 text-start d-flex flex-column" style={{ padding: '5px 8px 2px 7px' }}>
                                                                <p className="text-small  " style={{ fontWeight: 600 }}>{one.title}</p>
                                                                {one.height > 30 && (
                                                                    <div className="flexc mt-1 " style={{}}>
                                                                        <img className="invert" src="https://cdn-icons-png.flaticon.com/512/37/37663.png" height="10px" style={{ opacity: 1 }} />
                                                                        <p className="text-smaller mx-1 " style={{ color: '#fff' }}>{moment(one.sTime).format('HH:mm')} - {moment(one.eTime).format('hh:mm')}</p>
                                                                    </div>
                                                                )}

                                                                {one.height > 70 && (
                                                                    <div className=" mt-2 pt-2 d-flex flex-column pb-1" style={{ flex: 1, borderTop: '1px solid #f2f6f8' }}>
                                                                        <p className="text-smaller  " style={{ color: '#789' }}>Pouya Pezhman</p>
                                                                        <div className="d-flex mt-1 w-100" style={{ flex: 1, alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                                                                            <p className="text-smaller  py-1 px-2 text-bold" style={{ color: '#789', backgroundColor: '#f2f6f8', borderRadius: 4 }}>Not Payed</p>
                                                                        </div>
                                                                    </div>
                                                                )}


                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                                // }
                                            })}
                                        </div>
                                    </div>
                                )
                            })}

                            {this.state.timeIndicatorTop >= 0 && (
                                <div className="position-absolute w-100" style={{ backgroundColor: '#ee5050aa', height: 1, top: this.state.timeIndicatorTop }}></div>
                            )}
                        </div>



                    </div>

                </div>




                {this.props.isLoading && (
                    <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', backgroundColor: '#00000020', position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>

                    </div>
                )}

            </div>
        );
    }
}

export default Day;
